import styled from 'styled-components'

export const Title = styled.h5`
  font-size: 20px;
  font-weight: 700;
  margin-top: 25px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW90};
`
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const XButtonWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 20px;
  svg {
    cursor: pointer;
    width: 24px;
  }
`

export const DescriptionCounter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 12px;
  font-weight: 400;
`
